// @flow
import React from 'react';
import type { Element } from 'react';
import filters from '@globalConstants/departmentTranslationCodes';
import { withTranslation, Router } from '@i18n';
import { FINDER_PACKAGE, PACKAGE_FILTER } from '@routes';
import { connect } from 'react-redux';
import compose from 'lodash/fp/compose';
import { sortQueryParams } from '@lib/helpers';
import StyledSelectComponent from './components/StyledSelectComponent';
import StyledSelect from './components/StyledSelect';

import { StyledWrapper, StyledSearchUnit } from './styles';

import type { Props } from './types';
import { requestPackageListSearchBar } from '../redux/actions';

const SearchBar = ({
  t, query, SearchList
}: Props): Element<any> => {
  const setPosition = (target): void => {
    const params = sortQueryParams({ ...query, country: target.value || '', pageNumber: 1 }, [
      'treatment_id',
      'country',
      'pageNumber'
    ]);
    Router.pushRoute(PACKAGE_FILTER, params);
  };

  const setPackage = (target): void => {
    const params = sortQueryParams(
      {
        ...query,
        treatment_id: target.key || '',
        pageNumber: 1
      },
      ['treatment_id', 'country', 'pageNumber']
    );
    Router.pushRoute(FINDER_PACKAGE, params);
  };

  let packageNames = [];

  if (SearchList !== undefined) {
    const uniqueKeys = [];
    packageNames = SearchList.reduce((filtered, obj) => {
      if (!uniqueKeys.includes(obj.attributes.id)) {
        uniqueKeys.push(obj.attributes.id);
        filtered.push({
          key: obj.attributes.id,
          value: obj.attributes.name,
          label: obj.attributes.name
        });
      }
      return filtered;
    }, []);
  }
  const countryNames = filters.country.map(position => ({ value: position, label: position }));
  return (
    <StyledWrapper>
      <StyledSearchUnit size={{ mobile: 3 / 5, desktop: 2 / 3 }}>
        <StyledSelect
          label={t('Name')}
          name="package"
          isSearchable
          setPackage={setPackage}
          placeholder={t('treatment')}
          query={query}
          options={packageNames}
          onChange={setPackage}
        />
      </StyledSearchUnit>
      <StyledSearchUnit size={{ mobile: 2 / 5, desktop: 1 / 3 }}>
        <StyledSelectComponent
          label={t('Name')}
          name="country"
          isSearchable
          setPosition={setPosition}
          placeholder={t('CountryHeadline')}
          query={query}
          options={countryNames}
          onChange={setPosition}
        />
      </StyledSearchUnit>
    </StyledWrapper>
  );
};

const mapStateToProps = state => ({
  SearchList: state.packageFinder.searchData
});

export default compose(
  connect(
    mapStateToProps,
    {
      requestPackageListSearchBar
    }
  ),
  withTranslation(['ProfilePackages'])
)(SearchBar);
